import superagent from "superagent";
import { demo_asset_landings } from "./demo/assets";

export async function getAssetFromDemoData(code) {
  const asset = demo_asset_landings.find(asset => asset.share_code === code);
  if (asset) {
    return asset;
  }
  return undefined;
}

export async function getAsset(code) {
  let asset = await getAssetFromDemoData(code);
  if (!asset) {
    try {
      asset = await superagent
        .get(
          process.env.VUE_APP_API_ORIGIN + "/api/v1/assets/share-code/" + code
        )
        .then(({ body }) => {
          return body.data;
        });
    } catch (err) {
      console.error(err);
    }
  }
  return asset;
}
